import React from 'react';
import SuccessMessage from 'commonComponents/forms/SuccessMessageWithExperts/SuccessMessageWithExperts';
import InfoBar from 'commonComponents/sections/FormBoxSection/InfoBar/InfoBar';
import FormBoxSection from 'commonComponents/sections/FormBoxSection/FormBoxSection';
import { mergeObjects } from 'lib/utils/dataUtils';

/*eslint max-lines-per-function: ["error", 200]*/
const BaseContactPage = ({
  source,
  common,
  unique,
  token,
  sitekey,
  user,
  secondaryExperts
}) => { 
  const form = mergeObjects(common, unique);
  
  const { sidebar, thankyou, experts, fields } = form;
  const { email, phone, notes } = fields;
  email.size = '80';
  phone.size = '80';
  notes.rows = '2';

  const leadHiddenFields = [
    { name: 'sign_up_as', value: 'candidate' },
    { name: 'custom_lead_source', value: source }
  ];

  const expertsProps = [ ...experts ];
  expertsProps.forEach(expert => expert.isPrimary = true);

  if (secondaryExperts) {
    if (secondaryExperts.left) {
      expertsProps.unshift({ name: secondaryExperts.left });
    }
    if (secondaryExperts.right) {
      expertsProps.push({ name: secondaryExperts.right });
    }
  }

  const contactFormProps = {
    form,
    token,
    sitekey,
    user,
    orderOfFields: ['first_name', 'last_name', 'email', 'phone'],
    hiddenFields: leadHiddenFields,
    successBlock: () => <SuccessMessage { ...thankyou } experts={ expertsProps } />,
    sideBar: isShow => {
      return isShow &&
        <InfoBar { ...sidebar } experts={ expertsProps } />;
    }
  };

  return <FormBoxSection { ...contactFormProps } />;
};
 
export default BaseContactPage;
